import React from 'react'


const {invest, live} = I18n.t(`calculators.interest_matrix`);

class RatesPillContent extends React.Component {
  render() {
    return (
      <div className="rates__rates">
        <div className="rates-single">
          <div className="rates-number">
            <span className="rates-number__number">{this.props.variableRate}</span>
            <span className="rates-number__percent">%</span>
          </div>
          <p className="rates-caption">variable rate p.a.</p>
        </div>
        <div className="rates-single">
          <div className="rates-number">
            <span className="rates-number__number">{this.props.comparisonRate}</span>
            <span className="rates-number__percent">%</span>
          </div>
          <p className="rates-caption">comparison rate p.a.*</p>
        </div>
      </div>
    )
  }
}


class RatesPills extends React.Component {
  state = {
    currentPillIndex: 0
  };
  
  pillContents = [{
      title: 'Owner-occupier',
      variableRate: live.regular.payg_variable[0].toFixed(2),
      comparisonRate: live.regular.payg_variable[1].toFixed(2),
      disclaimer: 'Owner occupier P&I with LVR ≤60%'
    },
    {
      title: 'Investor',
      variableRate: invest.regular.payg_variable[0].toFixed(2),
      comparisonRate: invest.regular.payg_variable[1].toFixed(2),
      disclaimer: 'Investor P&I with LVR ≤80%'
    },
  ];
  
  render() {
    return (
      <div className="rates">
        <div className="rates__pills">
          { this.pillContents.map((pill, index) => (
            <button
              key={index}
              onClick={() => this.setState({currentPillIndex: index})}
              className={index === this.state.currentPillIndex ? 'active' : ''}
            >
              {pill.title}
            </button>
          ))}
        </div>
        <RatesPillContent
          variableRate={this.pillContents[this.state.currentPillIndex].variableRate}
          comparisonRate={this.pillContents[this.state.currentPillIndex].comparisonRate}
          disclaimer={this.pillContents[this.state.currentPillIndex].disclaimer}
        />
        <p className="rates-disclaimer mt-1">{this.pillContents[this.state.currentPillIndex].disclaimer}</p>
      </div>
    )
  }
}

export default RatesPills;
